module.exports = __webpack_public_path__ + "assets/52.jpg?68b158d3d8866abd40c97bffc18a1305";